import { Button } from '@mui/material';
import clsx from 'clsx';
import { useLocation } from 'react-router';

import { ReactComponent as GoogleIcon } from '../../../assets/icons/Login/googleIcon.svg';
import useMixpanel from '../../../hooks/useMixpanel';
import { getPortalRuntimeConfig } from '../../../services/runtimeConfig';
import { getRedirectUriDetails } from '../redirect';
import styles from './index.module.scss';

export default function GoogleButton() {
  const { trackClick } = useMixpanel();
  const location = useLocation();
  const state = location.state ?? {};
  const { cognito } = getPortalRuntimeConfig();
  const { redirectUri, state: redirectState } = getRedirectUriDetails({
    redirectUri: window.location.origin + '/login',
    state: state?.redirectTo ?? new URLSearchParams(location.search).get('returnTo') ?? undefined,
  });
  return (
    <Button
      variant="contained"
      className={clsx(styles.ssoBtn, 'rounded-4')}
      onClick={() => {
        trackClick('login_with_google');
        window.location.replace(
          `${cognito.url}/oauth2/authorize?identity_provider=Google&redirect_uri=${redirectUri}&response_type=TOKEN&client_id=${cognito.clientId}&scope=openid+profile&prompt=select_account&state=${encodeURIComponent(redirectState)}`,
        );
      }}
      role="link"
    >
      <GoogleIcon />
      Sign in with Google
    </Button>
  );
}
